import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=39ad90c3&scoped=true&"
import script from "./Sponsors.vue?vue&type=script&lang=js&"
export * from "./Sponsors.vue?vue&type=script&lang=js&"
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=39ad90c3&lang=scss&scoped=true&"
import style1 from "./Sponsors.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad90c3",
  null
  
)

export default component.exports